import { Autocomplete, TextField } from '@mui/material';
import { SupplierDirectoryRow } from '../../../../types/advise';
import { supplierKey } from './supplierKey';
import { CURRENT_SUPPLIER_NAME_LIMIT } from './currentSupplierLimits';

export interface CurrentSupplierNameFieldProps {
  name: string;
  picked: SupplierDirectoryRow | null;
  directory: SupplierDirectoryRow[];
  disabled: boolean;
  // Typing over a picked name drops its catalog entry.
  onChange: (name: string, picked: SupplierDirectoryRow | null) => void;
}

/** The UPSTACK supplier catalog to search, keeping whatever is typed when the supplier isn't listed. */
export const CurrentSupplierNameField = ({
  name,
  picked,
  directory,
  disabled,
  onChange
}: CurrentSupplierNameFieldProps) => (
  <Autocomplete
    freeSolo
    size="small"
    disabled={disabled}
    options={directory}
    value={picked}
    inputValue={name}
    getOptionLabel={(option) => (typeof option === 'string' ? option : option.supplier_name)}
    isOptionEqualToValue={(option, value) => supplierKey(option) === supplierKey(value)}
    onChange={(_, value) => {
      if (value && typeof value !== 'string') onChange(value.supplier_name, value);
    }}
    onInputChange={(_, value, reason) => {
      if (reason === 'input' || reason === 'clear') onChange(value, null);
    }}
    renderOption={(props, option) => (
      <li
        {...props}
        key={supplierKey(option)}>
        {option.supplier_name}
      </li>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        inputProps={{ ...params.inputProps, maxLength: CURRENT_SUPPLIER_NAME_LIMIT }}
        required
        label="Supplier"
        placeholder="Search the UPSTACK supplier catalog, or type a name"
      />
    )}
  />
);
